import { render, staticRenderFns } from "./newsContent.vue?vue&type=template&id=04adae71&scoped=true&"
import script from "./newsContent.vue?vue&type=script&lang=js&"
export * from "./newsContent.vue?vue&type=script&lang=js&"
import style0 from "./newsContent.vue?vue&type=style&index=0&id=04adae71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04adae71",
  null
  
)

export default component.exports